/**
 * FACILITY-4 · WHERE THE PRO'S REQUEST STANDS, in one line (Facility plan, section 5): "Marco took
 * this at 7:12 and will contact you", then "Marked fixed — the studio is confirming". The name of
 * whoever took it and nothing else — never the vendor's number; the vendor has the pro's.
 */
export function proStatusLine(t: { status: string; acknowledged_name?: string | null; acknowledged_at?: string | null }): string {
  const who = t.acknowledged_name?.trim();
  if (t.status === 'resolved' && who) return `${who} marked it fixed — the studio is confirming.`;
  if (who) {
    const at = t.acknowledged_at
      ? new Date(t.acknowledged_at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
      : null;
    return `${who} took this${at ? ` at ${at}` : ''} and will be in touch.`;
  }
  return 'The studio has your request.';
}
